<template>
  <div class="row reports-chart-summary">
    <div class="col" :class="{'d-sm-flex flex-sm-column': fullHeight}">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12 d-flex align-items-center mb-3">
              <span v-if="title" class="subtitle">{{ $t(title) }}</span>
              <button
                v-if="allowExportData && !emptyData"
                :title="$t(titleExportData)"
                class="btn btn-link min-w-auto font-small text-decoration-none z-depth-0 py-0 m-0"
                type="button"
                @click.prevent="onExport"
              >
                <img class="export" :src="assetsPathTheme('/icons/download.svg')">
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="!emptyData"
        class="row"
        :class="{'flex-grow-1': fullHeight}"
      >
        <div class="col-12">
          <div class="card border-0" :class="{'h-100': fullHeight}">
            <div class="card-body p-0 ratio">
              <canvas :id="id" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="emptyData && loaded" class="row">
        <div class="col">
          {{ notFoundMsg }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import ChartClass from '@/app/shared/components/charts/ChartClass';
    import { HasReport } from '@/app/shared/mixins/parts';
    import { MethodsExportData, PropsExportData } from '@/app/shared/mixins/parts/HasExportData';
    import GlobalMixin from '@/app/shared/mixins/global';
    import { isEmptyObject, makeColors } from '@config/utils';

    export default {
        name: 'ReportChartGroup',
        mixins: [
            PropsExportData,
            MethodsExportData,
            HasReport,
            GlobalMixin
        ],
        props: {
            id: {
                type: String,
                required: true,
            },
            type: {
                type: String,
                required: true,
                validator: function (value) {
                    return ['pie', 'horizontalBar', 'bar'].indexOf(value) !== -1
                }
            },
            field: {
                type: String,
                default: 'total',
            },
            fullHeight: {
                type: Boolean,
                default: true,
            },
            config: {
                type: Object,
                default: () => ({}),
            },
            color: {
                type: String,
                default: 'rgba(116, 151, 255, 1)'
            }
        },
        data() {
            return {
                loaded: false,
            }
        },
        created() {
            this.loaded = false;
            this.$nextTick(() => {
                ChartClass.create(this.type, this.id, this.id, true, this.config);
            })
        },
        computed: {
            emptyData: function() {
                return isEmptyObject(this.data);
            }
        },
        watch:{
            'data': {
                handler(){
                    this.drawChart();
                },
                deep: true,
            },
        },
        methods: {
            drawChart() {
                this.loaded = true;
                if (this.emptyData) {
                    return;
                }

                let labels = [];
                let data = [];
                // let color = [];
                let datasets = [];
                for (const date in this.data) {
                    const bars = this.data[date];
                    labels.push(date);
                    // colorIndex = 0;
                    for (const labelBar in bars) {
                        const bar = bars[labelBar];
                        if(!data[labelBar]) {
                            data[labelBar] = [];
                        }
                        data[labelBar].push(bar);
                    }
                }
                const colors = makeColors(Object.keys(data).length);
                let size = 0;
                for (const labelBar in data) {
                    datasets.push({
                        data: data[labelBar],
                        backgroundColor: colors[size],
                        borderWidth: 1,
                        stack: labelBar,
                        label: labelBar,
                    });
                    size++;
                }
                this.$nextTick(() => {
                    ChartClass.updateData(this.id, labels, datasets);
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "@styles/_mixins.scss";
    .ratio {
        position: relative;
        width: 100%;
        --bs-aspect-ratio: calc(9 / 16 * 100%);
        @include md {
            --bs-aspect-ratio: calc(3 / 10 * 100%);
        }
        &::before {
            display: block;
            padding-top: var(--bs-aspect-ratio);
            content: "";
        }
        & > * {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
</style>